'use client'
import { Intro } from '@/components/parts/intro/Intro'
// import { AnchorRequest } from '../../parts/AnchorRequest'
import FunctionsMain from '../../parts/functions/FunctionsMain'
import FunctionsOption from '../../parts/functions/FunctionsOption'
import { DocumentForm } from '../../forms/DocumentForm'
import { Contact } from '@/components/parts/contact'
import { Department } from '@/types/newt/department'
import { Opportunity } from '@/types/newt/opportunity'

type FunctionsPageProps = {
  departments: Department[]
  currentUrl: string
  opportunities: Opportunity[]
}

const FunctionsContent: React.FC<FunctionsPageProps> = ({
  departments,
  opportunities,
  currentUrl
}) => {
  return (
    <>
      <Intro
        title="機能一覧"
        lead="様々な機能であなたのドキュメント作成を<br>あらゆる面からサポート・効率化します"
      />
      <FunctionsMain />
      <FunctionsOption />
      {/* <AnchorRequest position="" /> */}
      <DocumentForm
        bg="bg-formbg"
        departments={departments}
        opportunities={opportunities}
      />
      <Contact bg="bg-lawguebase" />
    </>
  )
}

export default FunctionsContent
